export default {
  edit_note: 'Editar nota',
  add_note: 'Añadir nota ',
  update: 'Actualizar artículo',
  feedback: {
    item_sold_out_one: 'Lo sentimos, actualmente no tenemos disponible {{items}}.',
    item_sold_out_other: 'Lo sentimos, actualmente no tenemos disponible {{items}}.',
    item_unavailable:
      'Este artículo solo está disponible desde {{schedule}}. Por favor, cambia la hora del pedido o elimina el artículo para continuar.',
  },
  buttons: {
    update: 'Actualizar',
  },
};
